export function builQueryString(params) {
  if (!params || typeof params !== "object") return "";

  const queryParts = [];

  for (const [key, value] of Object.entries(params)) {
    // Skip undefined, null, and empty strings
    if (value === undefined || value === null || value === "") continue;

    // Arrays → repeat params (tags=dev&tags=node)
    if (Array.isArray(value)) {
      value.forEach((v) => {
        if (v !== undefined && v !== null && v !== "") {
          queryParts.push(
            encodeURIComponent(key) + "=" + encodeURIComponent(String(v))
          );
        }
      });
      continue;
    }

    // Normal values
    queryParts.push(
      encodeURIComponent(key) + "=" + encodeURIComponent(String(value))
    );
  }

  return queryParts.length > 0 ? "?" + queryParts.join("&") : "";
}

/* -------------------------------------------------
   Utility Function 1: Convert object to string
-------------------------------------------------- */
export function objectToString(obj, joiner = "-") {
  if (!obj || typeof obj !== "object") return "";
  return Object.entries(obj)
    .map(([k, v]) => `${k}${joiner}${v}`)
    .join("_");
}

/* -------------------------------------------------
   Utility Function 2: Filter out empty/null values
-------------------------------------------------- */
export function fiterFilters(filters = {}, discardFields = []) {
  const cleaned = {};

  Object.keys(filters).forEach((key) => {
    // Skip fields that should be discarded
    if (discardFields.includes(key)) return;

    const value = filters[key];

    // Skip empty or invalid values
    if (
      value === undefined ||
      value === null ||
      value === "" ||
      value === "ALL"
    ) {
      return;
    }

    cleaned[key] = value;
  });

  return cleaned;
}
